import { FC } from "react";
import classNames from "classnames";

import { ITitleWithRightContentProps } from "./types";
import Title from "../Title/Title";

import styles from "./TitleWithRightContent.module.css";


const TitleWithRightContent: FC<ITitleWithRightContentProps> = ({ label, className, rightContent }) => {
  return <div className={classNames(styles['title'], className)}>
    <Title label={label} />
    <div className={styles["title__right"]}>
      {rightContent}
    </div>
  </div>;
};

export default TitleWithRightContent;
